<template>
	<div class="pxrwwfgv-screen-dombvidek">
		<drawer-menu title="Dombvidék" />
		<DraggingIntervention />
		<DropSpots />
		<GameControls />
	</div>
</template>

<script setup >
	import {useStore} from 'vuex';

	import DrawerMenu from './ScreenGame/DrawerMenu.vue';
	import DraggingIntervention from './ScreenGame/DraggingIntervention.vue';
	import DropSpots from './ScreenGame/DropSpots.vue';
	import GameControls from './ScreenGame/GameControls.vue';

	const store = useStore();

	store.dispatch('setEndVideos', [
		require('@/assets/videos/dv_failure.webm'),
		require('@/assets/videos/dv_normal.webm'),
		require('@/assets/videos/dv_success.webm'),
	]);

	store.dispatch('setInterventions', [
		{
			id: 1,
			title: 'erdősítés és gyepesítés',
			desc: 'A legmeredekebb dombokon csak az erdő vagy a gyep tudja megvédeni a talajt a lemosódástól.',
			thumbnail: require('@/assets/images/icons/ikon_DV_01_erdosites.svg'),
			correctLocations: [5],
		},
		{
			id: 2,
			title: 'szivárgó rönkgátak',
			desc: 'A szivárgó rönkgátak nagy esőkor megfogják a hordalékot, lassítják a lefolyást, segítik a beszivárgást.',
			thumbnail: require('@/assets/images/icons/ikon_DV_02_ronkgat.svg'),
			correctLocations: [1,2],
		},
		{
			id: 3,
			title: 'oldaltározó tó',
			desc: 'Az árvizet felfogja a patak melletti víztározóban, ezzel ellaposítja az árvízcsúcsot és elraktározza a vizet.',
			thumbnail: require('@/assets/images/icons/ikon_DV_03_oldaltarozo.svg'),
			correctLocations: [3],
		},
		{
			id: 4,
			title: 'természetesebb patakmeder',
			desc: 'Egyenes és mély meder helyett változatos, kanyargós és fákkal kísért patakban lassabb a víz sebessége.',
			thumbnail: require('@/assets/images/icons/ikon_DV_04_patakmeder.svg'),
			correctLocations: [6],
		},
		{
			id: 5,
			title: 'patakpart felszabadítása',
			desc: 'A patakhoz túl közel, veszélyeztetett zónába épült építmények, kerítések távolabb helyezése a parttól.',
			thumbnail: require('@/assets/images/icons/ikon_DV_05_patakpart.svg'),
			correctLocations: [7],
		},
		{
			id: 6,
			title: 'sövények és cserjesávok',
			desc: 'A lejtőre merőleges sövények és bokros sávok lelassítják a csapadékvíz lefolyását és mérséklik az eróziót.',
			thumbnail: require('@/assets/images/icons/ikon_DV_06_cserjesav.svg'),
			correctLocations: [4],
		},
	]);

	store.dispatch('setDropSpots', [
		{
			id: 1,
			coords: [1186,270],
		},
		{
			id: 2,
			coords: [565,322],
		},
		{
			id: 3,
			coords: [1032,451],
		},
		{
			id: 4,
			coords: [1580,460],
		},
		{
			id: 5,
			coords: [470,504],
		},
		{
			id: 6,
			coords: [1170,524],
		},
		{
			id: 7,
			coords: [1020,790],
		},
	]);
</script>

<style scoped>
	.pxrwwfgv-screen-dombvidek {
		background-image: url('@/assets/images/background_dombvidek.svg');
		/*background-image: url('@/assets/images/background_DV_drop_spots.svg');*/
	}
</style>